import PropTypes from 'prop-types';
import React, {PureComponent} from 'react';
import _ from 'lodash';
import RaisedButton from 'material-ui/RaisedButton';
import {getCategoryInfo, getRecentlyUsedCategories, getSuggestedCategories} from 'MyAccount/Listings/listingsHelper';
import CategorySelectorDialog from '../CategorySelectorDialog';
import {getUpdatedEbayListingValues} from '../ebayListingSelectors';
import AbstractListerField from './AbstractListerField';
import ListerTextField from './ListerTextField';
import {FIELD_NAMES, FIELD_WIDTH} from '../consts';
import connectWithRouter from 'shared/components/redux/connectWithRouter';

export class CategorySelector extends PureComponent {
  state = {
    open: false,
    dialogKey: 1,
    selectedCategoryNamePath: null,
    suggestedCategories: null,
  };

  componentWillMount() {
    this.updateSelectedCategoryNamePath();
    this.getSuggestedCategories();
    getRecentlyUsedCategories(this.props.site);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.value !== nextProps.value) {
      this.updateSelectedCategoryNamePath(nextProps);
    }
    if (this.props.listingTitle !== nextProps.listingTitle || this.props.site !== nextProps.site) {
      this.getSuggestedCategories(nextProps);
    }
    if (!this.props.open && nextProps.open) {
      this.openDialog();
    }
    if (this.props.site !== nextProps.site) {
      getRecentlyUsedCategories(nextProps.site);
    }
  }

  getSuggestedCategories = (props = this.props) => {
    const {site, listingTitle} = props;
    if (listingTitle && site) {
      getSuggestedCategories(listingTitle, site).then(result => {
        if (result.success) {
          this.setState({suggestedCategories: result.data});
        }
      });
    }
  };

  getCategoryPathForDisplay = () => {
    const {selectedCategoryNamePath} = this.state;
    const {value} = this.props;
    let categoryPathString = '';
    if (!_.isNil(value)) {
      _.forEach(selectedCategoryNamePath, (categoryName, index) => {
        categoryPathString += index === _.size(selectedCategoryNamePath) - 1 ? `${categoryName}` : `${categoryName} > `;
      });
    }
    return <div style={{marginTop: 10, height: 25}}>{categoryPathString}</div>;
  };

  updateSelectedCategoryNamePath = (props = this.props) => {
    const {site, value} = props;
    if (value) {
      getCategoryInfo(value, site).then(result => {
        if (result.success) {
          // TODO category validation should be here
          const updatedCategoryNamePath = result.selectedCategory ? result.selectedCategory.CategoryNamePath : '';
          this.setState({selectedCategoryNamePath: updatedCategoryNamePath});
        }
      });
    } else {
      this.setState({selectedCategoryNamePath: null});
    }
  };

  handleClose = categoryId => {
    const {handleClose} = this.props;
    if (handleClose) {
      handleClose();
    }
    if (categoryId) {
      this.handleCategoryChange(categoryId);
    }
    this.setState({open: false});
  };

  handleCategoryChange = newValue => {
    const {onChange} = this.props;
    onChange(newValue);
  };

  openDialog = () => {
    const {dialogKey} = this.state;
    this.setState({open: true, dialogKey: dialogKey + 1});
  };

  render() {
    const {open, dialogKey, suggestedCategories} = this.state;
    const {value, disabled, dialogOnly, id} = this.props;
    const dialog = (
      <CategorySelectorDialog
        key={dialogKey}
        open={open}
        handleClose={this.handleClose}
        initialCategoryId={value}
        suggestedCategories={suggestedCategories}
      />
    );
    return dialogOnly ? (
      dialog
    ) : (
      <div>
        <div style={{display: 'flex', alignItems: 'baseline'}}>
          <ListerTextField
            id={id}
            floatingLabelText="Category number"
            value={value || ''}
            onChange={this.handleCategoryChange}
            style={{position: 'relative', bottom: -4}}
            disabled={disabled}
            {..._.pick(this.props, ['errorStyle', 'errorText', 'width', 'onBlur'])}
          />
          <RaisedButton
            id="cla-btn-change-category"
            style={{marginLeft: 20}}
            label="CHANGE CATEGORY"
            onClick={this.openDialog}
            disabled={disabled}
          />
        </div>
        {this.getCategoryPathForDisplay()}
        {dialog}
      </div>
    );
  }
}

CategorySelector.defaultProps = {
  errorStyle: {position: 'absolute', bottom: -8}, // this is redundant inside the lister but makes it easier to use the category selector outside the lister.
};

const ListerCategorySelector = connectWithRouter(state => ({
  site: _.get(getUpdatedEbayListingValues(state), FIELD_NAMES.EBAY_SITE),
  listingTitle: _.get(getUpdatedEbayListingValues(state), FIELD_NAMES.EBAY_TITLE),
}))(CategorySelector);

ListerCategorySelector.propTypes = {
  width: PropTypes.oneOf(_.values(FIELD_WIDTH)),
  errorText: PropTypes.string,
};

ListerCategorySelector.defaultProps = {
  width: FIELD_WIDTH.S,
};

// קל this should be used when a ListerField inner type is wrapped with @connect
_.assign(ListerCategorySelector.contextTypes, AbstractListerField.contextTypes);

export default ListerCategorySelector;
